<template>
<div>
    <nav style="background-color: rgb(0, 79, 113);">
        <div class="container">
            <div class="verify-google-translate-holder ml-auto text-black m-2" style="width: 200px;"></div>
        </div>
    </nav>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-6 residentportal-default__column-full-height d-flex align-items-center justify-content-center">
                <div class="residentportal-default-left">
                    <h2 class="residentportal-default-left__title">{{LandingPageContent.login_heading}} </h2>
                    <div v-html="LandingPageContent.registration_content"></div>
                </div>
                <div class="residentportal-default-left__bg centered-bg-image" v-bind:style="'background: url('+ landingPageImage +'); box-shadow: rgba(0, 45, 81, 0.5) 0px 0px 0px 2000px inset'" ></div>
            </div>
            <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center justify-content-center">
            <div class="m-lg-5 my-5 d-flex flex-column align-items-center justify-content-center">
                    <img :src="'img/padlock.png'" class="mb-4 w-25">
                    <h2 v-if="codeStatus == '200'" class="font-xxxl font-weight-bold mb-2 text-center">Email verification successful</h2>
                    <p v-if="codeStatus == '200'" class="text-center mb-4">Thank you</p>
                    <h2 v-if="codeStatus != '200'" class="font-xxxl font-weight-bold mb-2 text-center">{{message}}</h2>
                <p v-if="codeStatus == '400' && message == 'Expired Token'" class="text-center mb-4">Sorry, the email verification link may have been expired, <br/><button class="btn-link" @click="resendConfirmationEmail" :disabled="!!saving">click here</button> to resend verify email</p>
                    <a v-if="message == 'Email verification successful' || message == 'Email was sent successfully'" href="#" @click.prevent="$router.push('/')">Go back to login page</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import GoogleTranslateMixin from "../common/mixins/GoogleTranslateMixin";
    export default {
        data() {
            return {
                mainURL: process.env.MIX_MAIN_URL,
                pubPath: process.env.MIX_APP_URL,
                codeStatus: '',
                message:'',
                saving: false
            }
        },
        mixins: [GoogleTranslateMixin],
        beforeDestroy() {
            $(this.$root.$refs.googleTranslateElement).appendTo('.google-translate-holder');
        },
        methods: {
            mainSiteLink: function(){
                location.href = this.$store.getters.GET_LANDING_PAGE_CONTENT.login_button_link;
            },
            checkCodeStatus() {
            var hashCode = this.$route.query.tk;
            this.$store.dispatch('checkRegConfirmation', hashCode);
            },
            resendConfirmationEmail() {
            this.saving = true;
            var hashCode = this.$route.query.tk;
            this.$store.dispatch('resendConfirmationEmail', hashCode);
            }
            
        },
        computed: {
        MainUISettings() {
            return this.$store.getters['GET_MAIN_UI']; 
        },
        landingPageImage() {
            var landingImagePath = this.MainUISettings.landing_page_image
            if(landingImagePath){
                landingImagePath = landingImagePath.split("\\").join("/")
                landingImagePath = this.pubPath + landingImagePath
            }
            return landingImagePath; 
        },
        LandingPageContent() {
            return this.$store.getters['GET_LANDING_PAGE_CONTENT']; 
        },
        getCodeStatus() {
            return this.$store.getters.GET_REGISTER_CONFIRMATION.codeStatus
        },
        getMessage(){
            return this.$store.getters.GET_REGISTER_CONFIRMATION.message
        },
        resendEmailURL(){
            return this.$store.getters.GET_RESEND_CONFIRMATION_EMAIL.message
        }
        },
        mounted() {
            // this.$store.dispatch('mainUI');
            this.$store.dispatch('landingPageContent');
            setTimeout(() => {
                this.checkCodeStatus();
            }, 1000);

            $('div#google_translate_element').appendTo('.verify-google-translate-holder');
        },
        watch: {
            'getCodeStatus': function(codeStatus) {
                this.$nextTick(function() {
                this.codeStatus = codeStatus
                });
            },
            'getMessage': function(message) {
                this.$nextTick(function() {
                this.message = message
                });
            },
            'resendEmailURL': function(message) {
                this.$nextTick(function() {
                this.message = message
                });
            }
        }
    }
</script>
